export enum OccurrenceEnum {
  NOW = "now",
  LATER = "later",
}
